import { error } from "@sveltejs/kit";

/**
 * Safely handles any error and throws a SvelteKit-compatible error.
 * - If the error is already a SvelteKit error, it rethrows it.
 * - If the error message is JSON, attempts to parse it and extract a meaningful message.
 * - Logs the error with status code and message.
 *
 * @param {unknown} err - The caught error
 * @param {object} [context] - Optional context to help log where the error occurred
 * @param {string} [context.prefix] - String to prepend to logs for context
 * @param {number} [context.defaultStatus=500] - Status to throw if err.status is undefined
 */
export function handleError(err, { prefix = "", defaultStatus = 500 } = {}) {
  const errStatus = err?.status || err?.code || defaultStatus;

  let message = typeof err === "string" ? err : err?.message || "Unknown error";
  try {
    const parsed = JSON.parse(message);
    if (parsed?.message) {
      message = parsed.message; // contentful errors are returned as structured json
    }
  } catch {
    // Not JSON, something else went wrong,
    // ignore and use original message
  }
  const logPrefix = prefix ? `[${prefix}] ` : "";

  throw error(errStatus, `${logPrefix}Error ${errStatus}: ${message}`);
}
